/* eslint-disable consistent-return */
import { get } from 'lodash'
import React, { useEffect } from 'react'
import { Redirect, withRouter, useHistory } from 'react-router-dom'
import { Spinner } from 'reactstrap'
import { connect } from 'react-redux'
import { ssoLoginRequest } from '_legacy/actions'
import { SsoLoginState } from 'legacy/reducers/reducer.ssoLogin'
import { getSsoAccessToken } from '_helpers/storage'
import { User } from '_types/User'

interface SsoLoginProps {
  location: any
  ssoLogin: SsoLoginState
  signInUser: User
  dispatchSsoLoginRequest: (req: any) => void
}

const SsoLogin: React.FC<SsoLoginProps> = ({
  location,
  ssoLogin,
  signInUser,
  dispatchSsoLoginRequest,
}) => {
  const history = useHistory()

  const shouldRedirect = () => {
    const jwtRegex = /(^[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*$)/

    const signSession = sessionStorage.getItem('signSession')
    const getAuthToken = signSession && JSON.parse(signSession)
    const token = get(getAuthToken, 'authToken')

    return jwtRegex.test(token)
  }

  useEffect(() => {
    const ssoTokenPayload = getSsoAccessToken(location.hash)

    if (!ssoTokenPayload) {
      history.push('/sso-failed?s=400')
      return
    }

    dispatchSsoLoginRequest({ ssoToken: ssoTokenPayload })
  }, [location.hash])

  useEffect(() => {
    if (signInUser.authToken) history.push('/member-search')
    if (ssoLogin.error) history.push(`/sso-failed?s=${ssoLogin.error}`)
  }, [signInUser, ssoLogin])

  if (ssoLogin.loader) {
    return (
      <div className="text-center overlay">
        <Spinner color="dark" className="loader-centivo" />
      </div>
    )
  }

  if (shouldRedirect()) return <Redirect to="/member-search" />

  return <div />
}

const mapStateToProps = (state: any) => ({
  ssoLogin: state.ssoLogin,
  signInUser: state.signInUser,
})

const mapDispatchToProps = (dispatch: any) => ({
  dispatchSsoLoginRequest: (reqObj: any) => dispatch(ssoLoginRequest(reqObj)),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SsoLogin)
)
